import React from 'react';
import { Button, Tooltip } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { getSmsCabinetUrl } from '../../config/smsCabinet';

type Props = {
  inverted?: boolean;
  size?: 'small' | 'medium';
};

/** Ширина по макету; остальное — из темы (smsby: pill #FFB300 37px) */
const CABINET_WIDTH_SX = { width: 169, mr: 0.5 };

const SmsCabinetBackButton: React.FC<Props> = () => {
  const { t } = useTranslation();
  const url = getSmsCabinetUrl();
  if (!url) return null;

  return (
    <Tooltip title={t('botConstructor.backToSmsCabinet', 'Вернуться в кабинет SMS')}>
      <Button
        component="a"
        href={url}
        variant="contained"
        color="primary"
        startIcon={<ArrowBackIcon sx={{ fontSize: 18 }} />}
        sx={CABINET_WIDTH_SX}
      >
        {t('botConstructor.cabinetShort', 'В кабинет')}
      </Button>
    </Tooltip>
  );
};

export default SmsCabinetBackButton;
